import * as z from "zod";

export const refreshTeamRates = {
  name: "refreshTeamRates" as const,
  input: z.object({}),
  output: z.object({ started: z.boolean() }),
};
